<template>
  <div class="topActionBar">
    <img class="icon" src="@/assets/images/no-connection.png">
    <div class="textContainer">
      <div class="title">
        İnternet bağlantısı sağlanamadı
      </div>
      <div class="desc">
        Bilgisayarınızın internete bağlı olduğundan emin olunuz.
      </div>
      <div class="reconnect" @click="reconnect" v-if="false">
        Tekrar bağlan <img class="reconnectIcon" src="@/assets/images/right-arrow-reconnect.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {},
  methods: {
    reconnect () {}
  }
}

</script>

<style scoped>
  .topActionBar {
    background-color: #FED859;
    border-bottom: rgb(223, 223, 223) 1px solid;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .icon {
    width: 50px;
    height: 50px;
    margin-left: 15px;
  }

  .textContainer {
    display: flex;
    flex-direction: column;
    padding-left: 20px;
    padding-right: 40px;
  }

  .title {
    font-size: 16px;
  }

  .desc {
    font-size: 14px;
    margin-top: 5px;
  }

  .reconnect {
    text-decoration: underline;
    cursor: pointer;
  }

  .reconnectIcon {
    width: 10px;
    height: 10px;
  }
</style>
